import { render } from "./AllExerciseSheetQuestionTypes.vue?vue&type=template&id=c99dea64"
import script from "./AllExerciseSheetQuestionTypes.vue?vue&type=script&lang=js"
export * from "./AllExerciseSheetQuestionTypes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__